/* eslint-disable camelcase */

import React from 'react'
import { RadioGroup } from '../../ui'

// Local import
import { updateErrors } from '../SectionField'
import TrashCanIcon from '../../ui/icons/TrashCanIcon'
import DuplicateIcon from '../../ui/icons/DuplicateIcon'
import PictureField from '../BasicFields/PictureField'
import SelectField from '../BasicFields/SelectField'

class Picture extends React.Component {
  constructor(props) {
    super(props)

    this.variables = this.getImageVariables()
    this.state = {
      id: props.question.id,
      context: props.question.context,
      position: props.question.position,
      picture: props.question.picture,
      variable_id: props.question.variable_id,
      isDynamic: props.question.isDynamic || Boolean(props.question.variable_id),
      changed: props.question.changed || false,
      errors: props.question.errors || {}
    }
  }

  shouldComponentUpdate(_nextProps, nextState) {
    this.state.errors = updateErrors(this.state.errors, this.props.getErrors)
    return (
      this.state.picture !== nextState.picture ||
      this.state.variable_id !== nextState.variable_id ||
      this.state.isDynamic !== nextState.isDynamic ||
      this.state.position !== nextState.position ||
      this.state.errors.isNew === true
    )
  }

  componentDidUpdate() {
    this.props.handleQuestionChange(this.state)
  }

  getImageVariables = () => {
    if (this.props.data && this.props.data.variables)
      return this.props.data.variables.filter(variable => variable.variable_type === 'image')

    return []
  }

  getErrors = () => this.state.errors

  handlePictureChange = files => {
    this.setState({
      picture: files[0],
      changed: true
    })
  }

  handleVariableChange = event => {
    this.setState({
      variable_id: event.target.value,
      changed: true
    })
  }

  handleSourceChange = isDynamic => {
    const defaultVariableId = this.props.question.variable_id ||
      this.variables.length > 0 && this.variables[0].id || null

    let changed = true
    if (!isDynamic && this.state.picture?.id)
      changed = false

    this.setState({
      variable_id: isDynamic ? defaultVariableId : null,
      isDynamic,
      changed
    })
  }

  render() {
    const sourceOptions = [
      {
        id: `image_static_${this.state.id}`,
        value: false,
        label: 'Image unique'
      },
      {
        id: `image_dynamic_${this.state.id}`,
        value: true,
        label: 'Variable image'
      }
    ]

    return (
      <div className="nested-fields ml-2 ml-md-4 ">
        <div className="d-flex">
          <div className="mr-auto">
            <i className="fas fa-arrows-alt c-pointer" {...this.props.dragHandleProps} />
            {' Image '}
            <DuplicateIcon
              className="tw:text-gray-500 tw:hover:text-gray-700 c-pointer"
              onClick={this.props.handleQuestionDuplicate(this.state.id)}
            />
          </div>
          <TrashCanIcon
            className="tw:text-gray-500 tw:hover:text-gray-700 c-pointer"
            onClick={this.props.handleQuestionRemove(this.state.id)}
          />
        </div>
        <RadioGroup
          name={`image_source_${this.state.id}`}
          options={sourceOptions}
          value={this.state.isDynamic}
          label="Source de l'image"
          inline
          onChange={this.handleSourceChange}
        />
        {this.state.isDynamic ? (
          <>
            <SelectField
              name={`${this.props.name}.variable_id`}
              label="Variable Image"
              data={this.variables.map(variable => ({ id: variable.id, name: variable.name }))}
              value={this.state.variable_id}
              errors={this.state.errors.variable}
              includeBlank={false}
              onChange={this.handleVariableChange}
            />
            {this.variables.length === 0 && (
              <div className="text-muted small mt-1">
                Aucune variable image disponible. Créez d&apos;abord une variable de type image.
              </div>
            )}
          </>
        ) : (
          <div className="form-group">
            <PictureField
              name="picture"
              value={this.state.picture}
              files={this.state.picture ? [this.state.picture] : []}
              getErrors={this.getErrors}
              onChange={this.handlePictureChange}
            />
          </div>
        )}
      </div>
    )
  }
}

export default Picture
